import { useEffect, useState } from 'react';

export const MOBILE_VIEWPORT_QUERY = '(max-width: 767px)';
export function useMobileViewport() {
  const [mobile, setMobile] = useState(() => window.matchMedia?.(MOBILE_VIEWPORT_QUERY).matches ?? false);
  useEffect(() => {
    const media = window.matchMedia?.(MOBILE_VIEWPORT_QUERY);
    if (!media) return;
    const update = () => setMobile(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return mobile;
}
